import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface WindowData {
  id?: string; // 창 식별자
  data?: any; // any data, 이 창에서 사용할 데이터
  senderIdList?: string[]; // 발신자 아이디 리스트
  receiverIdList?: string[]; // 수신자 아이디 리스트
}

interface InterWindowState {
  windows: Record<string, WindowData>;
}

const initialState: InterWindowState = {
  windows: {},
};

const initialWindowData: WindowData = {
  id: "",
  data: null,
  senderIdList: [],
  receiverIdList: [],
};

const interWindow = createSlice({
  name: "interWindow",
  initialState,
  reducers: {
    // 새로운 창이 열렸을때 초기화
    storeSpecificWindowData: (state, action: PayloadAction<WindowData>) => {
      state.windows = {
        ...state.windows,
        [action.payload.id]: {
          ...initialWindowData,
          ...action.payload,
        },
      };
    },
    // 모든 창 리셋
    resetInterWindow: (state) => {
      state.windows = {};
    },
    // 특정 창 리셋
    resetSpecificWindow: (state, action: PayloadAction<{ id: string }>) => {
      state.windows[action.payload.id] = {
        ...state.windows[action.payload.id],
        data: null,
      };
    },
    // 특정 창 삭제
    deleteSpecificWindow: (state, action: PayloadAction<{ id: string }>) => {
      delete state.windows[action.payload.id];
    },
    // 특정 창에 발신자 아이디 추가
    addSenderId: (state, action: PayloadAction<{ id: string; senderId: string[] }>) => {
      state.windows[action.payload.id].senderIdList = [
        ...state.windows[action.payload.id].senderIdList,
        ...action.payload.senderId,
      ];
    },
    // 특정 창에 수신자 아이디 추가
    addReceiverId: (state, action: PayloadAction<{ id: string; receiverId: string[] }>) => {
      state.windows[action.payload.id].receiverIdList = [
        ...state.windows[action.payload.id].receiverIdList,
        ...action.payload.receiverId,
      ];
    },
    // 특정 창에 발신자 아이디 삭제
    removeSenderId: (state, action: PayloadAction<{ id: string; senderId: string[] }>) => {
      state.windows[action.payload.id].senderIdList = state.windows[
        action.payload.id
      ].senderIdList.filter((id) => !action.payload.senderId.includes(id));
    },
    // 특정 창에 수신자 아이디 삭제
    removeReceiverId: (state, action: PayloadAction<{ id: string; receiverId: string[] }>) => {
      state.windows[action.payload.id].receiverIdList = state.windows[
        action.payload.id
      ].receiverIdList.filter((id) => !action.payload.receiverId.includes(id));
    },
  },
});

export const {
  storeSpecificWindowData,
  resetInterWindow,
  resetSpecificWindow,
  deleteSpecificWindow,
  addSenderId,
  addReceiverId,
  removeSenderId,
  removeReceiverId,
} = interWindow.actions;

export default interWindow.reducer;
export const selectWindowData = (state: RootState, id: string) => state.interWindow.windows[id];
export const selectWindowDataList = (state: RootState) => state.interWindow.windows;
